import { useState } from "react";
import { CoalitionSection } from "../CoalitionSection";
import { CoalitionModal } from "..//CoalitionModal";
import { CoalitionCardStamps } from "../CoalitionCardStamps";
import { CoalitionCardStampsDetail } from "..";
import { empty_stamps } from "../../pngs";
import { EmptyBlock } from "./EmptyBlock";
import { sendTag, event_properties_101_03 } from "../CoalitionGtm";
import {
  stampsLabel,
  privGtmKey,
  toggleScrollLock,
  getCardDetail,
} from "../../utils";

export const StampsBlock = ({ stamps }) => {
  const [modal, setModal] = useState(null);
  const [isShown, setIsShown] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const gtm = localStorage.getItem(privGtmKey);

  const toggleModal = (cardId = null) => {
    setIsShown(Boolean(cardId));
    toggleScrollLock();
    setActiveCard(getCardDetail(stamps, cardId));
  };
  const showModalFn = (cardId, k, i) => {
    toggleModal(cardId);
    if (gtm) {
      let payload = event_properties_101_03();
      payload.punch_card_id = i.id;
      payload.punch_card_progress = stampsLabel(i);
      payload.banner_index = k;
      sendTag(gtm, payload);
    }
  };

  const title = "Junta tus sellos";
  const emptyDesc =
    "Muy pronto podrás llevarte tus productos favoritos de regalo al juntar tus sellos";
  const filledDesc =
    "Acumula compras y llévate tus productos favoritos de regalo";
  const modalTitle = "Todo sobre tus sellos";

  return (
    <>
      {!stamps || stamps.length === 0 ? (
        <EmptyBlock
          title={title}
          description={emptyDesc}
          emptyState={empty_stamps}
          isBlock={true}
        />
      ) : (
        <>
          <CoalitionSection title={title} subtitle={filledDesc}>
            {stamps.map((i, k) => (
              <CoalitionCardStamps
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                description={i.description}
                used={i.balance}
                needed={i.required_balance}
                availableToRedeem={i.available_to_redeem}
                showModal={(cardId, k) => showModalFn(cardId, k, i)}
              />
            ))}
          </CoalitionSection>
          {isShown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={modalTitle}
            >
              <CoalitionCardStampsDetail card={activeCard} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
